import Vue from "vue";
import Vuex from "vuex";
import { IUserState } from "./modules/user";
import { ITagsViewState } from "./modules/tagsView";
import { IAppState } from "./modules/app";
import { IPermissionState } from "./modules/permission";


Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  user: IUserState;
  tagsView: ITagsViewState;
  permission: IPermissionState;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
